import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3402/api';

const getAxiosInstance = () => {
  const token = localStorage.getItem('token');
  return axios.create({
    baseURL: API_URL,
    headers: {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    },
  });
};

export interface GiftSummary {
  id: string;
  code: string;
  months: number;
  status: 'PENDING_PAYMENT' | 'ACTIVE' | 'REDEEMED' | 'CANCELED' | 'EXPIRED' | 'REFUNDED';
  amount: number;
  currency: string;
  purchasedAt: string;
  tier: { name: string };
  creatorProfile: { displayName: string };
}

export const giftsService = {
  purchaseGift: async (params: { tierId: string; months: number; recipientEmail?: string; recipientName?: string; message?: string; deliverAt?: string; }) => {
    const api = getAxiosInstance();
    const { data } = await api.post('/gifts/purchase', params);
    return data as { giftId: string; code: string; checkoutUrl: string; sessionId: string };
  },
  listMine: async () => {
    const api = getAxiosInstance();
    const { data } = await api.get('/gifts/mine');
    return (data.gifts || []) as GiftSummary[];
  },
  getByCode: async (code: string) => {
    const api = getAxiosInstance();
    const { data } = await api.get(`/gifts/code/${encodeURIComponent(code)}`);
    return data.gift as { code: string; months: number; tier: any; creatorProfile: any };
  },
  redeem: async (code: string) => {
    const api = getAxiosInstance();
    const { data } = await api.post('/gifts/redeem', { code });
    return data as { message: string; membershipId: string; subscriptionId?: string };
  }
};
